import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import {
  DriverEmailField,
  DriverLicenseNumberField,
  DriverNameField,
  DriverPhoneNumberField,
} from '@src/permitTypesManager/permitTypeSections/DriverInformationFields';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const DriverInformationSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();
  const fields: SectionField[] = [
    {
      field: DriverNameField,
      label: t('fields.driverName'),
    },
    {
      field: DriverPhoneNumberField,
      label: t('fields.driverPhone'),
    },
    {
      field: DriverEmailField,
      label: t('fields.driverEmail'),
    },
    {
      field: DriverLicenseNumberField,
      label: t('fields.driverLicenseNumber'),
    },
  ];
  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList sectionFields={fields} control={control} />
    </Stack>
  );
};
